export default "__VITE_ASSET__342dc63a__"